require('./userFeedService');
require('./userFeedSortService');
require('../../shared/singleClipService');
require('../../favorites/favoritesService');
require('../../shared/clipCategoryService');

"use strict";

angular.module('app.shared.userFeed.userFeedController', [
  'app.shared.userFeed.userFeedService',
  'app.shared.userFeed.userFeedSortService',
  'app.shared.singleClipService',
  'app.favorites.favoritesService',
  'app.shared.clipCategoryService'
])
  .controller('app.shared.userFeed.userFeedController', [
    '$scope',
    'app.shared.userFeed.userFeedService',
    '$filter',
    'app.shared.userFeed.userFeedSortService',
    'app.shared.singleClipService',
    'app.favorites.favoritesService',
    'app.shared.clipCategoryService',
    function ($scope, userFeed, $filter, userFeedSort, singleClip, favorites, clipCategoryService) {
      $scope.userFeed = userFeed.new();
      $scope.userFeedSort = userFeedSort;
      $scope.userId = $scope.userId || null;
      $scope.favorites = favorites;
      $scope.limitFavorites = $scope.limitFavorites || false;
      $scope.feed = [];
      $scope.feedType = $scope.feedType || null;
      $scope.groupingCount = 5;

      $scope.pager = {
        items: [],
        pageSize: 50,
        currentPage: 1,
        pageChanged: function () {
          if (Array.isArray($scope.feed)) {
            let start = (this.currentPage - 1) * this.pageSize;
            let end = start + this.pageSize;

            if (!$scope.feedType) {
              let items = $scope.feed.slice(start, end);
              this.items = [];

              let last_type = null, item_group = null;
              let item_count = items.length;
              _.each(items, (item, index) => {
                let reset = item.type != last_type;

                if (reset || index >= (item_count - 1)) {
                  this.items.push(item_group);
                }

                if (reset) {
                  last_type = item.type;
                  item_group = {
                    type: item.type,
                    items: [],
                    expanded: false
                  };
                }
                item_group.items.push(item);
              });
            } else {
              this.items = $scope.feed.slice(start, end);
            }
          }
        },
        reset: function () {
          this.currentPage = 1;
          this.pageChanged();
        },
        max_grouping: 5
      };

      $scope.show_type_filter = !$scope.feedType;
      $scope.item_types = {};
      $scope.clip_categories = {};

      $scope.formatDate = function (start, end) {
        let start_date = moment(start),
          end_date = moment(end);

        return start_date.format('MMMM DD-') + end_date.format('DD, YYYY');
      };

      $scope.filters = {
        type: null,
        clip: {
          category: null
        },
        sort_option: userFeedSort.default_option
      };

      let init = function () {
        clipCategoryService.getCategories().then(
          function (response) {
            $scope.clip_categories = response.data;
          }
        );

        $scope.feedType = $filter('singularize')($filter('dasherize')($scope.feedType));
        retrieveFeed();
      };

      let retrieveFeed = function () {
        let params = null;

        let overrideLimitFavorites =
          Array.isArray(favorites.selected)
          && favorites.selected.length === 1
          && favorites.selected[0] === 10;

        if (!overrideLimitFavorites && $scope.limitFavorites) {
          params = {
            favorites: favorites.selected
          };
        }
        let type = $filter('pluralize')($scope.feedType);
        $scope.userFeed.retrieve($scope.userId, type, params)
          .then(() => {
            $scope.error = null;
          })
          .catch();
      };

      $scope.getFilterType = function () {
        if ($scope.feedType) {
          return $scope.feedType;
        }
        else {
          return $scope.filters.type;
        }
      };

      $scope.sort_feed = function () {
        $scope.feed = userFeedSort.sort($scope.userFeed.items, $scope.filters.sort_option, $scope.getFilterType());
        $scope.pager.reset();
      };

      $scope.isFilterVisible = function (filter) {
        switch (filter) {
          case 'type':
            return $scope.show_type_filter;
          case 'clip_category':
            if ($scope.getFilterType() !== 'clip') {
              return false;
            }
        }
        return true;
      };

      $scope.is_visible = function (item) {
        let filterType = $scope.getFilterType();
        if (filterType) {
          if (filterType !== item.type) {
            return false;
          }
          if ($scope.isFilterVisible('clip_category') && $scope.filters.clip.category) {
            if (parseInt($scope.filters.clip.category) !== item.clip_category.iclipcategoryid) {
              return false;
            }
          }
        }
        return true;
      };

      $scope.toggleLike = function (item) {
        switch (item.type) {
          case 'clip':
            singleClip.toggle_like(item.iclipid)
              .then(function (response) {
                let data = response.data;

                let likes = parseInt(data.likes);
                if (isNaN(likes)) {
                  likes = 0;
                }

                item.likes = likes;
                item.i_like = data.i_like;

                let item_index = $scope.feed.findIndex((i) => {
                  return (i.type === 'clip' && i.iclipid === item.iclipid)
                });
                if (item_index > -1) {
                  $scope.feed[item_index] = item
                }

                item_index = $scope.userFeed.items.findIndex((i) => {
                  return (i.type === 'clip' && i.iclipid === item.iclipid)
                });
                if (item_index > -1) {
                  $scope.userFeed.items[item_index] = item
                }
              });
            break;
        }
      };

      $scope.remove = function (item) {
        switch (item.type) {
          case 'clip':
            let remove = confirm("Are you sure you want to delete this clip?");
            if (remove) {
              singleClip.delete(item.iclipid).then(function (response) {
                if (response.status === 204) {
                  let index = $scope.feed.indexOf(item);
                  if (index !== -1) {
                    $scope.feed.splice(index, 1);
                  }

                  index = $scope.userFeed.items.indexOf(item);
                  if (index !== -1) {
                    $scope.feed.splice(index, 1);
                  }

                  $scope.pager.pageChanged();
                }
                else if (response.data && response.data.error) {
                  alert(response.data.error);
                }
              });
            }
        }
      };

      //convert API values for use by UI
      let convertTempItemValues = function (item) {

        item.iispublic = item.iispublic ? "1" : "0";
        item.iperiod = item.iperiod ? item.iperiod.toString() : "0";

        return item;
      };

      $scope.lockRange = function (obj, ref, min, max) {

        let returnVal = true;

        if (obj) {
          if (obj[ref] < min || !obj[ref]) {
            obj[ref] = min;
          } else if (obj[ref] > max) {
            obj[ref] = max;
          }
        } else {
          returnVal = false;
        }

        return returnVal;
      };

      $scope.editClip = function (item) {

        let tempItem = JSON.parse(JSON.stringify(item));

        if (!item.meta) {
          item.meta = {};
        }

        if (tempItem.meta) {
          delete tempItem.meta;
        }

        item.meta.hasError = false;

        tempItem = convertTempItemValues(tempItem);

        item.meta.tempItem = tempItem;
        item.meta.isEditing = true;
      };

      $scope.saveEditClip = function (item) {

        let fieldsToUpdate = {
          "strclipname": item.meta.tempItem.strclipname,
          "dteclipdate": item.meta.tempItem.dteclipdate,
          "strsourceduration": item.meta.tempItem.strsourceduration,
          "iispublic": item.meta.tempItem.iispublic == "1",
          "iperiod": parseInt(item.meta.tempItem.iperiod),
          "itimeinseconds": item.meta.tempItem.clockTime ? ((item.meta.tempItem.clockTime.minute * 60) + item.meta.tempItem.clockTime.second) : 0,
          "strsourcestart": item.meta.tempItem.startClockTime ? (((item.meta.tempItem.startClockTime.hour * 60) * 60) + (item.meta.tempItem.startClockTime.minute * 60) + item.meta.tempItem.startClockTime.second) : 0,
          "iclipcategoryid_fk": item.meta.tempItem.iclipcategoryid_fk,
          "ihlw": item.meta.tempItem.ihlw,
          "ihc": item.meta.tempItem.ihc,
          "ihrw": item.meta.tempItem.ihrw,
          "ihld": item.meta.tempItem.ihld,
          "ihrd": item.meta.tempItem.ihrd,
          "ialw": item.meta.tempItem.ialw,
          "iac": item.meta.tempItem.iac,
          "iarw": item.meta.tempItem.iarw,
          "iald": item.meta.tempItem.iald,
          "iard": item.meta.tempItem.iard,
        };

        let clockFields = {
          "clockTime": item.meta.tempItem.clockTime,
          "startClockTime": item.meta.tempItem.startClockTime,
        };

        singleClip.updateClip(item.meta.tempItem.iclipid, fieldsToUpdate)
          .then(function (response) {
            let data = response.data;

            if (data.error) {
              alert(data.error);
            }
            else {
              fieldsToUpdate = $.extend(fieldsToUpdate, clockFields);

              for (let prop in fieldsToUpdate) {
                item[prop] = fieldsToUpdate[prop];
              }
              item.iispublic = (fieldsToUpdate.iispublic) ? "1" : "0";
            }
          });

        item.meta.isEditing = false;

      };

      $scope.collegeCommitmentTeamName = function (item, type) {
        if (item[type]) {
          return item[type].strteamname + ' ' + item[type].strteammascot;
        }
        else {
          return item[type + '_name'];
        }
      };

      $scope.commitmentYear = function (item) {
        let year = moment(item.comm_year).year();
        return year + '-' + (year + 1).toString().substring(2);
      };

      $scope.close_game_eval = function (item) {
        if (item.type === 'favorite-game' && item.overlay && item.overlay.strperiod.charAt(0) === '3') {
          if (Math.abs(item.overlay.iawayscore - item.overlay.ihomescore) <= 1) {
            item.is_close_game = true;
            return true;
          }
        }

        return false;
      };

      $scope.$watch(function () {
        return $scope.userId;
      }, function () {
        return init();
      });

      $scope.$watch(function () {
        return $scope.userFeed.items;
      }, function () {
        return $scope.sort_feed();
      });

      $scope.$on('favorites_selected', function () {
        if ($scope.limitFavorites) {
          retrieveFeed();
        }
      });

      $scope.$on('favorites_updated', function () {
        if ($scope.limitFavorites) {
          retrieveFeed();
        }
      });
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/shared/userFeed/userFeedController.js